<template>
	<div>

		<el-drawer :visible.sync="isshow" :with-header="false" :before-close="handleClose" :modal="ismodal">

			<div class="detailArea" v-loading="loading">
				<div ref="getheight">
				<!--  -->
				<div class="detail-head FlexBetween outerpadd">
					<div class="head_left Flexalign">
						<div class="pup_title">
							{{ptitle}}
						</div>
						
						<slot name="headselect"></slot>
					</div>

					<div class="head_right Flexalign" v-show="is_recycle == 1">
						<el-tooltip content="恢复" placement="bottom" effect="light">
							<el-button class="drawer_btn" icon="el-icon-edit" @click="head_btnClick(4)"></el-button>
						</el-tooltip>
						<el-tooltip content="彻底删除" placement="bottom" effect="light">
							<el-button class="drawer_btn" icon="el-icon-suitcase" @click="head_btnClick(5)"></el-button>
						</el-tooltip>
						<el-tooltip content="编辑" placement="bottom" effect="light">
							<el-button class="drawer_btn" icon="el-icon-edit-outline"
								@click="head_btnClick(3)"></el-button>
						</el-tooltip>
					</div>

					<div class="head_right Flexalign" v-show="is_recycle == 0">
						<el-tooltip content="新建跟进" placement="bottom" effect="light">
							<el-button class="drawer_btn" icon="el-icon-edit" @click="head_btnClick(1)"></el-button>
						</el-tooltip>
						<template v-if="types == 6">
							<el-tooltip content="转合同" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-suitcase"
									@click="head_btnClick(2)"></el-button>
							</el-tooltip>
						</template>
						<template v-else-if="types == 8">
							<el-tooltip content="添加回款" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-suitcase"
									@click="head_btnClick(2)"></el-button>
							</el-tooltip>
						</template>
						<el-tooltip content="编辑" placement="bottom" effect="light">
							<el-button class="drawer_btn" icon="el-icon-edit-outline"
								@click="head_btnClick(3)"></el-button>
						</el-tooltip>
						<el-dropdown>
							<el-button type="text" class="drawer_btn-more" icon="el-icon-more">
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="2" @click.native="switchState(1)">
									转让
								</el-dropdown-item>
								<el-dropdown-item :command="3" @click.native="switchState(2)">
									添加协同人
								</el-dropdown-item>
								<el-dropdown-item :command="4" @click.native="switchState(3)">
									删除
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						
						<el-tooltip content="关闭" placement="bottom" effect="light" style="margin: 0;">
							<el-button class="drawer_btn" icon="el-icon-close" @click="handleClose"></el-button>
						</el-tooltip>
					</div>

				</div>
				<!--  -->
				<!--  -->
				<div class="detail-top Flexalign">
					<div>
						<!--  -->
						<div class="isfatherArea Flexalign ">
							<div class="title_txt Flexalign">
								<div class="tit">
									{{ drawer_info_title }}
								</div>
							</div>
						</div>
						<!--  -->
						<!--  -->
						<div class="det_topinfo Flexalign">
							<div class="mem_txt" v-if="drawer_info.member_name">
								{{ drawer_info.member_name || "" }}
							</div>
							<div class="mem_txt" v-else-if="drawer_info.member">
								{{ drawer_info.member.name || "" }}
							</div>
							<div class="txts">
								创建于{{ drawer_info.create_time || "" }},
								{{ drawer_info.update_time ? '最近更新于'+ drawer_info.update_time : '暂无更新'}}
							</div>
						</div>
						<!--  -->
					</div>
				</div>
				<!--  -->
				</div>
				<!--  -->
				<div class="detail_content " >
					<div class="container_tabs outerpadd">
						<!--  -->
						<el-tabs class="eltabs" v-model="activeName">
							
							<el-tab-pane label="信息" name="1">
								<div class="eltabs_info FlexWrap" v-if="stablelist.length">
									<template v-for="(item,index) in stablelist">
										<div class="eltabs_item Flexalign" >
											<div class="eltabs_label">{{ item.field }}</div>
											<div class="eltabs_text Flexalign">
												<div class="member_area FlexRow" v-if="item.character">
													<i class="iconfont icon-a-lujing131"></i>
												</div>
												<div class="txt Singlerow">
													{{ item.select_field || "暂无" }}
												</div>
											</div>
										</div>
									</template>
								</div>
								<template v-if="types == 6">
									<div class="demand_area">
										<div class="detit">
											商机需求
										</div>
										<div class="decontent" v-html="demand_content">
											
										</div>
									</div>
								</template>
							</el-tab-pane>
							<el-tab-pane label="详细" name="2">
								<detailsdisplay :classlist="curClass_list" :fieldlist="curField_list">
								</detailsdisplay>
							</el-tab-pane>

							<el-tab-pane label="跟进" name="3">
								<followupbox :types="types" :show="activeName == '3'" :content_id="content_id">
								</followupbox>
							</el-tab-pane>

							<el-tab-pane label="关联产品" name="4" v-if="types < 9 && types != 7">
								<addproduct ref="prodarea" :show="activeName == '4'" :realtime="true"
									:pro_list="productlist" @getlist="saveproduct"></addproduct>
							</el-tab-pane>

							<!--  -->
							<el-tab-pane label="关联附件" name="5"> 
								<div :class="{'isdisabled': types == 10 || types == 11}">
									<enclofile ref="detail_clofile" :btnshow="btnshow" :isnoshow="true"
										:enclist="filelist" :realtime="true" @setupfile="setupfile">
									</enclofile>
								</div>
							</el-tab-pane>
							<!-- 订单 -->
							<template v-if="types == 10">
								<el-tab-pane label="产品" name="6">
									<productinfor ref="productiref"  :ispup="true"
									:isshow="activeName == '6'"	:goodslist="drawer_info.order_goods" :isShow="true"></productinfor>
								</el-tab-pane>
								<el-tab-pane label="回款" name="7">
									<relatedcollection :show="activeName == '7'" :return_id="drawer_info.return_id">
									</relatedcollection>
								</el-tab-pane>
							</template>
							<!-- 报价单 -->
							<template v-if="types == 11">
								<el-tab-pane label="产品" name="6">
									<productinfor ref="productiref"  :ispup="true"
									:isshow="activeName == '6'"	:goodslist="drawer_info.quotation_goods" :isShow="true"></productinfor>
								</el-tab-pane>
							</template>
							
							

						</el-tabs>
						<!--  -->
					</div>

					<!--  -->
					<div class="content-container_bottom">
						<div class="container_bottom_tabs">
							<el-tabs class="bottom_eltabs" v-model="activeLog">
								
								
								
								<el-tab-pane  name="5">
									<operationlog :show="islogshow" :types="log_types" :content_id="content_id"
									@retnum="(e)=> operalog_num = e">
									</operationlog>
									<!--  -->
									<template slot="label">
										<div class="b_navItem FlexRow" :class="{'isActive': activeLog == '5'}">
											<span>
												操作日志
											</span>
											<div class="num_box" v-if="operalog_num">
												{{operalog_num}}
											</div>
										</div>
									</template>
									<!--  -->
								</el-tab-pane>
								<el-tab-pane>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
					<!--  -->

				</div>
				<!--  -->
				
			</div>
			<div class="pupclose FlexColumn" @click="handleClose">
				<i class="el-icon-arrow-right"></i>
			</div>
		</el-drawer>

	</div>
</template>

<script>
	import {
		JudgmentRequ,
		fn_retjson,
		retJSONArr,
	} from "network/defaults";
	// 详情信息
	import detailsdisplay from "./detailsdisplay.vue"
	// 操作日志
	import operationlog from "@/components/tabledata/operationlog.vue";
	// 关联产品
	import addproduct from "./addproduct.vue"
	// 关联附件
	import enclofile from "./enclofile.vue"
	// 跟进显示
	import followupbox from "../association/followupbox.vue"
	
	import relatedcollection from "../association/relatedcollection.vue";
	import productinfor from "../productinfor.vue";
	
	import {
		xmde_del,
		recycle_project,
	} from "network/hk_operset";
	import {
		timestampToTime,
	} from "network/kh_public";
	import {
		editCustomer2,
	} from "network/hk_customer";
	export default {
		name: "detailspup",
		components: {
			detailsdisplay,
			operationlog,
			followupbox,
			addproduct,
			enclofile,
			
			relatedcollection,
			productinfor,
		},
		props: {
			
			ptitle: { // 
				type: String,
				default: '',
			},
			dinfo: { // 详情信息
				type: String,
				default: '',
			},
			is_recycle: { // 回收站
				type: Number,
				default: 0,
			},
			powerobj: { // 权限
				type: Object | String,
				default: '',
			},
			types: { // 类型  6 商机 7.項目 8.合同 9.回款 10.订单
				type: Number,
				default: 1,
			},
			classlist: { // 字段分类列表
				type: Array,
				default: () => {
					return [];
				},
			},
			fieldlist: { // 字段数据列表
				type: Array,
				default: () => {
					return [];
				},
			},
			memberlist: { // 成员列表
				type: Array,
				default: () => {
					return [];
				},
			},
			prodlist: { // 产品列表
				type: Array,
				default: () => {
					return [];
				},
			},
			enclist: { // 附件列表
				type: Array,
				default: () => {
					return [];
				},
			},
			stablelist: { // 信息
				type: Array,
				default: () => {
					return [];
				},
			},
			
			content_id: { // 当前推出详情id
				type: Number,
				default: 0,
			},
			isshow: { // 推出是否显示
				type: Boolean,
				default: false,
			},
			loading: { // 数据是否加载完成
				type: Boolean,
				default: true,
			},
			ismodal: { // 
				type: Boolean,
				default: false,
			},
			
		},
		data() {
			return {
				operalog_num: 0,
				
				demand_content: '',
				drawer_info: '', // 详情数据
				activeName: '1',
				activeLog: "5",
				windowHeight: window.innerHeight,
				curClass_list: [], // 当前 分类列表
				curField_list: [], // 当前 字段列表
				log_types: -1, // 操作日志 参数
				islogshow: false, // 操作日志
				drawer_info_title: '', // 标题
				productlist: [], // 当前 产品列表
				filelist: [], // 当前 附件列表
				
				row_height: "",
				
				btnshow: true, 
			
			};
		},
		created() {
			this.islogshow = false
		},
		watch: {
			isshow() {
				this.activeName = '1'
				this.islogshow = false
				this.operalog_num = 0
				if (this.isshow) {
					this.setDatas()
					this.getvanhe()
				} else {
					this.drawer_info = ''

				}
			},
			dinfo() {
				this.islogshow = false
				if (this.dinfo) {
					this.setDatas()
				} else {
					this.drawer_info = ''
				}
			},
			fieldlist() {
				let newArr1 = this.headledata(this.fieldlist)
				this.curField_list = fn_retjson(newArr1)
			},
			enclist() {
				// 附件列表
				this.filelist = fn_retjson(this.enclist)
			},
		},
		methods: {
			
			getvanhe() {
				setTimeout(() => {
					let h1 = document.documentElement.clientHeight;
					let h2 = this.$refs.getheight ? this.$refs.getheight.offsetHeight : 0;
					let num = h1 - h2 - 48;
					let height = `height: ${num}px`;
					this.row_height = height;
				}, 300);
			},
			// 关联产品修改保存
			saveproduct(e) {
				if (e) {
					this.$emit('saveproduct', e)
				}
			},
			// 关联附件修改保存
			setupfile(e) {
				if (e) {
					this.$emit('setupfile', e)
				}
			},
			// 更新当前弹窗
			fnupdatedet() {
				this.$emit('update')
			},
			// 处理数据
			headledata(arr) {
				if (arr.length) {
					for (let item of arr) {
						item.disabled = true
						let field_type = item.field_type
						let field = item.field || item.field_sign;
						if (field_type == 3 && item.select_field) { // 时间字段 时间戳转时间文字
							item.select_field = timestampToTime(item.select_field, true)
						}
						if (field == '协同人' || field == '协作人') {
							if (this.memberlist.length && item.content.length) {
								let res_arr = []
								for (let val of item.content) {
									let arr1 = this.memberlist.filter(v => v.member_id == val)
									let name = arr1[0] ? arr1[0].name : '';
									res_arr.push(name)
								}
								item.select_field = res_arr.length ? res_arr.join('、') : '';

							} else {
								item.select_field = ''
							}
						}
					}
				}
				return arr
			},
			// 设置数据
			setDatas() {

				let res = retJSONArr(this.dinfo)
				this.drawer_info = fn_retjson(res)
				this.drawer_info_title = this.drawer_info.name || this.drawer_info.customer_name;
				this.islogshow = false
				if (this.types == 9) { // 
					this.drawer_info_title = '回款编号:' + this.drawer_info.hk_code
				} else if (this.types == 10) { // 
					this.drawer_info_title = '订单编号:' + this.drawer_info.dd_code
				}
				else if (this.types == 11) { //
					this.drawer_info_title = '报价单编号:' + this.drawer_info.bd_code
				}

				setTimeout(() => {
					this.islogshow = true
				}, 350)
				// 字段分类
				this.curClass_list = fn_retjson(this.classlist)
				// 6：商机 7.項目  8：合同  9：回款  10：订单  11：报价单
				this.log_types = this.types
				// 产品列表
				this.productlist = fn_retjson(this.prodlist)
				// 附件列表
				this.filelist = fn_retjson(this.enclist)
				
				this.btnshow = (this.types == 10 || this.types == 11) ? false : true;
				
				
				   
				// 商机需求
				if(this.types != 6) return;
				let b_info = retJSONArr(res.business_info) || []
				if(b_info.length) {
					let ind_s = b_info.findIndex(v=>v.field_sign == '需求描述' || v.field == '需求描述')
					if(ind_s != -1 && b_info[ind_s]) {
						this.demand_content = b_info[ind_s].content 
					}
				}
			},
			handleClose() {
				this.$emit("update:isshow", false);
			},

			head_btnClick(flag) {
				this.$emit('btnClick', {
					flag
				})
			},
			switchState(flag) {
				this.$emit('switchState', {
					flag
				})
			},


		},
	};
</script>



<style scoped lang="scss">
	@import "@/assets/css/project/dpup.scss";
</style>